import React, { Component, Fragment } from "react";
import { BrowserRouter, Link, Switch, Route, Redirect } from 'react-router-dom';
import { StaticRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setTranslation } from './actions';
import isWindow from 'components/common/helpers/isWindow';

import ScrollToTop from 'components/common/ScrollToTop';
import axios from 'components/AppRequest';
//system components:
import Seo from './Seo';
// app layout
import Sidebar from './components/common/layouts/Sidebar';
import Header from './components/common/layouts/Header';
import { setUserLogged } from 'components/actions/authActions';
import Loader from 'components/components/common/layouts/Loader';
import Notifications from 'components/components/common/layouts/Notifications';
import originAxios from 'axios';
import RouteComponent from './RouteComponent';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import findAnimType from './utils/findAnimType';
import getRoutesList from './utils/routesList';
import PageBackground from 'components/components/common/layouts/PageBackground';
import TransHelper from 'components/common/translations/TransHelper';
import IosPrompt from 'components/components/IosPrompt';

// docs: https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/docs/guides/server-rendering.md
class Router extends Component {

  renderRouter = () => {
    if (typeof window !== 'undefined') {
      return (
        <BrowserRouter>
          {this.props.children}
        </BrowserRouter>
      )
    } else {
      return (
        <StaticRouter location={this.props.path} context={{}}>
          {this.props.children}
        </StaticRouter>
      )
    }
  }
  render() {
    return (this.renderRouter());
  }
}

class AppRouter extends React.Component {

  componentDidMount() {
    this.checkUserIsLogged();
  }

  checkUserIsLogged() {
    axios.post('/pwa/security/check-login')
      .then(response => {
        originAxios.post('/set-logged');
        this.props.setUserLogged(response.data);
      })
      .catch(err => {
        if (err.response) {
          originAxios.post('/unset-logged');
        }
      });
  }

  getAnimationType = (pathname, locale) => {
    if (isWindow) {
      if (window.prevPathApp) {
        var prevPath = window.prevPathApp;
      } else {
        var prevPath = pathname;
      }
      window.prevPathApp = window.location.pathname;
      return findAnimType(
        prevPath,
        pathname,
        locale
      );
    } else {
      return "fadeComponent";
    }
  }

  render() {
    const { locale, isLogged, ...serverProps } = this.props;
    var keyAp = 0;
    var url = TransHelper.translateRoute(locale, 'routes.url.dashboard');
    return (
      <Fragment>
        <Loader />
        <Seo />
        <div>
          <IosPrompt />
        </div>
        <div>
          <Notifications />
        </div>
        <Router {...this.props} >
          <ScrollToTop>
            <div id="root">
              <div id='wrapDiv'>
                <PageBackground locale={locale} />
                <div id='pageDiv'>
                  <Switch>
                    {
                      getRoutesList(locale).map((data) => {
                        return (
                          <Route
                            exact
                            path={data.path}
                            key={++keyAp}
                            render={(routeProps) => {
                              if ((data.path === "/" || data.path === "/:locale") && isLogged) {
                                return <Redirect to={url} />
                              } else {
                                var animationType = this.getAnimationType(
                                  routeProps.location.pathname,
                                  locale
                                );
                                return <TransitionGroup component={Fragment}>
                                  <CSSTransition
                                    key={data.path + keyAp}
                                    timeout={400}
                                    classNames={animationType}
                                    appear
                                    unmountOnExit
                                  >
                                    <RouteComponent
                                      routeData={data}
                                      layout={data.layout}
                                      key={keyAp}
                                      locale={locale}
                                      isLogged={isLogged}
                                      fetchPageData={data.fetchPageData}
                                      component={data.component}
                                      {...routeProps}
                                      {...serverProps}
                                    />
                                  </CSSTransition>
                                </TransitionGroup>
                              }
                            }
                            }
                          />
                        )
                      })
                    }
                  </Switch>
                  <Sidebar />
                </div>
              </div>
            </div>
          </ScrollToTop>
        </Router >
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    isLogged: state.app.isLogged
  }
}

export default connect(mapStateToProps, { setTranslation, setUserLogged })(AppRouter);
